import { useContext } from 'preact/hooks';
import { PlusIcon } from '../ecardsPreact.icons/PlusIcon';
import { UploadIcon } from '../ecardsPreact.icons/UploadIcon';
import { Steps } from '../ecardsPreact.constants/steps';
import { ECardGlobalState } from './ECardGlobalState';

export default function ECardAddRecipientsOptions(props) {
    const { hidden } = props;

    const { currentStep } = useContext(ECardGlobalState);

    return (
        <section class="ecard-form__section ecard-form__section--selector ecard-form__section--padded" hidden={hidden} aria-labelledby="recipients-options">
            <header class="ecard-form__header">
                <h1 class="text-h3 text-blue" id="recipients-options">
                    Add recipient(s)
                </h1>
                <p class="pt-2 lg:pt-8">Looking to send this card to more than one person? Simply add more recipients below.</p>
            </header>

            <div class="double-col-grid">
                <button
                    class="selector"
                    type="button"
                    onClick={() => {
                        currentStep.set(Steps.AddRecipientsManual);
                    }}
                >
                    <PlusIcon class="selector__icon" />
                    <span>Add manually</span>
                </button>

                <button
                    class="selector"
                    type="button"
                    onClick={() => {
                        currentStep.set(Steps.AddRecipientsCsv);
                    }}
                >
                    <UploadIcon class="selector__icon" />
                    <span>Upload from a CSV</span>
                </button>
            </div>
        </section>
    );
}
